/**
 * Quick-Create Communication drawer (sc-365239) — lightweight helpers with no
 * heavy dependencies, so entry-point components (e.g. the retention chart) can
 * import them without pulling in the offer/message schema graph.
 */
import {
  QuickCreateRetentionSource,
  QuickCreateSource,
} from './quick-create-communication.types';

/**
 * Story: the retention cohort's "days since last order" floor is the median
 * return-time + 20%, rounded **up** to the nearest whole number. A null median
 * (no data) yields 0.
 */
export const daysSinceLowerBound = (median: number | null): number =>
  median == null ? 0 : Math.ceil(median * 1.2);

/**
 * The Visit 1 cohort (0 lifetime visits) has no orders, so "days since last
 * order" can never match it — that stage targets days since signup instead.
 */
export const isFirstVisitCohort = (source: QuickCreateSource): boolean =>
  source.kind === 'retention' && source.lifetimeVisits === 0;

/** Story: the Visit 1 days-since-signup floor defaults to 1 (still editable). */
export const DAYS_SINCE_SIGNUP_DEFAULT = 1;

/**
 * Default "at least N days" floor for a retention cohort: days since signup for
 * Visit 1, otherwise the median + 20% days-since-last-order bound.
 */
export const defaultDaysFloor = (source: QuickCreateRetentionSource): number =>
  isFirstVisitCohort(source)
    ? DAYS_SINCE_SIGNUP_DEFAULT
    : source.daysSinceLastLowerBound;
